import React from 'react';
import { Box, Container } from '@mui/material';
import Dashboard from '../../components/Dashboard/Dashboard';

const DashboardPage: React.FC = () => {
    return (
        <Container maxWidth="xl">
            <Box py={3}>
                <Dashboard />
            </Box>
        </Container>
    );
};

export default DashboardPage; 